// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1or9B","content":"styles_content__14Kw-","checkbox":"styles_checkbox__3PjOP","checkboxLabel":"styles_checkboxLabel__KxUg9"};